import { useMemo, useState } from 'react';

function useSideDetail() {
  const [selectedData, setSelectedData] = useState(null);
  const displayData = useMemo(() => selectedData, [selectedData]);

  return { setSelectedData, displayData };
}

export default useSideDetail;
